// IMPORTANT: fieldsToSelect, keyColumn, and descColumn must match fields from ProductReferential
const DEFAULT_PRODUCT_CONFIG = {
    fieldsToSelect: ['barcode', 'barcodeDesc'],
    filterType: 'barcode',
    keyColumn: 'barcode',
    descColumn: 'barcodeDesc'
};
const ESP_PRODUCT_CONFIG = {
    fieldsToSelect: ['itemKey', 'itemDesc'],
    filterType: 'item',
    keyColumn: 'itemKey',
    descColumn: 'itemDesc'
};
// This constant defines which fields are used to retrieve holdings (in searchHoldings and findHoldings) based on the country
export const PRODUCT_FILTER_CONFIG_PER_COUNTRY = {
    FRA: DEFAULT_PRODUCT_CONFIG,
    ESP: ESP_PRODUCT_CONFIG,
    BEL: DEFAULT_PRODUCT_CONFIG
};
//# sourceMappingURL=productFilterConfigPerContry.constant.js.map